<div class="call-center-stats-container">
  <!-- Hét kiválasztó csúszka -->
  <app-week-selector
    [exportDisabled]="isExportDisabled()"
    [isExporting]="isExporting"
    (weekChanged)="onWeekChanged($event)"
    (exportRequested)="onExportRequested()">
  </app-week-selector>
  
  <!-- Loading állapot -->
  @if (isLoading) {
    <mat-card class="loading-card">
      <mat-card-content>
        <p>Munkatársak betöltése...</p>
      </mat-card-content>
    </mat-card>
  }
  
  <!-- Nincs aktív munkatárs -->
  @if (!isLoading && callCenterUsers.length === 0) {
    <mat-card class="no-staff-card">
      <mat-card-content>
        @if (isCallCenterEmployee()) {
          <p>Nincs elérhető statisztika az Ön számára.</p>
          <p><small>Ellenőrizze, hogy aktív Call Center munkatársként van-e regisztrálva.</small></p>
        } @else {
          <p>Nincs aktív "Call Center munkatárs" az adatbázisban.</p>
          <p><small>Ellenőrizze, hogy van-e is_active=true user "Call Center munkatárs" job title-lel.</small></p>
        }
      </mat-card-content>
    </mat-card>
  }
  
  <!-- Statisztikák táblázatok - csak bulk betöltés után renderelünk -->
  @if (!isLoading && callCenterUsers.length > 0 && preloadedWeekStats !== null) {
    <div>
      @for (user of callCenterUsers; track user.id) {
        <app-call-center-stats-table 
          [weekNumber]="selectedWeek?.weekNumber || 1"
          [weekData]="selectedWeek"
          [staffMember]="user"
          [preloadedStats]="preloadedWeekStats ? preloadedWeekStats[user.id] || null : null">
        </app-call-center-stats-table>
      }
    </div>
  }
  
  <!-- Összesítő tábla - csak adminoknak és vezetőknek -->
  @if (!isLoading && callCenterUsers.length > 0 && preloadedWeekStats !== null && (isAdmin() || isManager())) {
    <div class="summary-table-container">
      
      <app-call-center-stats-table 
        [weekNumber]="selectedWeek?.weekNumber || 1"
        [weekData]="selectedWeek"
        [staffMember]="null"
        [isSummaryTable]="true"
        [allStaffMembers]="callCenterUsers"
        [allPreloadedStats]="allPreloadedStatsArray">
      </app-call-center-stats-table>
    </div>
  }
</div>
